<template>
  <div>
    <b-form @submit="sendForm" @reset="onReset" v-if="show">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_professional_number"
            class="text-left required"
            :label="$t('doctor_create.professional_number_label')"
            label-for="input_professional_number"
            :invalid-feedback="form_invalid_feedback.professional_number"
            :state="form_state.professional_number"
          >
            <b-form-input
              id="input_professional_number"
              v-model.trim="form.professional_number"
              type="text"
              required
              :state="form_state.professional_number"
              :placeholder="$t('doctor_create.professional_number_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_specialty"
            class="text-left required"
            :label="$t('doctor_create.specialty_label')"
            label-for="input_specialty"
            :invalid-feedback="form_invalid_feedback.specialty"
            :state="form_state.specialty"
          >
            <b-form-input
              id="input_specialty"
              v-model.trim="form.specialty"
              type="text"
              required
              :state="form_state.specialty"
              :placeholder="$t('doctor_create.specialty_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_privacy"
            class="text-left required"
            :label="$t('doctor_create.privacy_label')"
            label-for="input_privacy"
            :invalid-feedback="form_invalid_feedback.privacy"
            :state="form_state.privacy"
          >
            <b-form-select
              id="input_privacy"
              v-model="form.privacy"
              required
              class="mb-3"
              :options="options_privacy"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_firstname"
            class="text-left required"
            :label="$t('doctor_create.firstname_label')"
            label-for="input_firstname"
            :invalid-feedback="form_invalid_feedback.firstname"
            :state="form_state.firstname"
          >
            <b-form-input
              id="input_firstname"
              v-model.trim="form.firstname"
              type="text"
              required
              :state="form_state.firstname"
              :placeholder="$t('doctor_create.firstname_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_lastname"
            class="text-left required"
            :label="$t('doctor_create.lastname_label')"
            label-for="input_lastname"
            :invalid-feedback="form_invalid_feedback.lastname"
            :state="form_state.lastname"
          >
            <b-form-input
              id="input_lastname"
              v-model.trim="form.lastname"
              type="text"
              required
              :state="form_state.lastname"
              :placeholder="$t('doctor_create.lastname_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_identification_type"
            class="text-left required"
            :label="$t('doctor_create.identification_type_label')"
            label-for="input_identification_type"
            :invalid-feedback="form_invalid_feedback.identification_type"
            :state="form_state.identification_type"
          >
            <b-form-select
              id="input_identification_type"
              v-model="form.identification_type"
              required
              class="mb-3"
              :options="options"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_identification_number"
            class="text-left required"
            :label="$t('doctor_create.identification_number_label')"
            label-for="input_identification_number"
            :invalid-feedback="form_invalid_feedback.identification_number"
            :state="form_state.identification_number"
          >
            <b-form-input
              id="input_identification_number"
              v-model.trim="form.identification_number"
              type="text"
              required
              :state="form_state.identification_number"
              :placeholder="$t('doctor_create.identification_number_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_identification_expiration"
            class="text-left required"
            :label="$t('doctor_create.identification_expiration_label')"
            label-for="input_identification_expiration"
            :invalid-feedback="form_invalid_feedback.identification_expiration"
            :state="form_state.identification_expiration"
          >
            <date-picker
              v-model.trim="form.identification_expiration"
              required
              :config="options_date"
            ></date-picker>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_country"
            class="text-left required"
            :label="$t('doctor_create.country_label')"
            label-for="input_country"
            :invalid-feedback="form_invalid_feedback.country"
            :state="form_state.country"
          >
            <CountrySelect
              v-model="form.country"
              :country="form.country"
              required
              :topCountry="deviceCountry"
              class="custom-select no-radius-select"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_address"
            class="text-left"
            :label="$t('doctor_create.address_label')"
            label-for="input_address"
            :invalid-feedback="form_invalid_feedback.address"
            :state="form_state.address"
          >
            <b-form-input
              id="input_address"
              v-model.trim="form.address"
              type="text"
              :state="form_state.address"
              :placeholder="$t('doctor_create.address_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_town"
            class="text-left"
            :label="$t('doctor_create.town_label')"
            label-for="input_town"
            :invalid-feedback="form_invalid_feedback.town"
            :state="form_state.town"
          >
            <b-form-input
              id="input_town"
              v-model.trim="form.town"
              type="text"
              :state="form_state.town"
              :placeholder="$t('doctor_create.town_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_colony"
            class="text-left"
            :label="$t('doctor_create.colony_label')"
            label-for="input_colony"
            :invalid-feedback="form_invalid_feedback.colony"
            :state="form_state.colony"
          >
            <b-form-input
              id="input_colony"
              v-model.trim="form.colony"
              type="text"
              :state="form_state.colony"
              :placeholder="$t('doctor_create.colony_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_postal_code"
            class="text-left"
            :label="$t('doctor_create.postal_code_label')"
            label-for="input_postal_code"
            :invalid-feedback="form_invalid_feedback.postal_code"
            :state="form_state.postal_code"
          >
            <b-form-input
              id="input_postal_code"
              v-model.trim="form.postal_code"
              type="text"
              :state="form_state.postal_code"
              :placeholder="$t('doctor_create.postal_code_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_federal_entity"
            class="text-left"
            :label="$t('doctor_create.federal_entity_label')"
            label-for="input_federal_entity"
            :invalid-feedback="form_invalid_feedback.federal_entity"
            :state="form_state.federal_entity"
          >
            <b-form-input
              id="input_federal_entity"
              v-model.trim="form.federal_entity"
              type="text"
              :state="form_state.federal_entity"
              :placeholder="$t('doctor_create.federal_entity_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            id="group_mobile"
            class="text-left required"
            :label="$t('doctor_create.mobile_label')"
            label-for="input_mobile"
            :invalid-feedback="form_invalid_feedback.mobile"
            :state="form_state.mobile"
          >
            <PhoneNumberInput id="input_mobile" v-model="form.mobile" size="sm" required></PhoneNumberInput>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_phone"
            class="text-left required"
            :label="$t('doctor_create.phone_label')"
            label-for="input_phone"
            :invalid-feedback="form_invalid_feedback.phone"
            :state="form_state.phone"
          >
            <PhoneNumberInput id="input_phone" v-model="form.phone" size="sm" required></PhoneNumberInput>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="group_phone_extension"
            class="text-left required"
            :label="$t('doctor_create.phone_extension_label')"
            label-for="input_phone_extension"
            :invalid-feedback="form_invalid_feedback.phone_extension"
            :state="form_state.phone_extension"
          >
            <b-form-input
              id="input_phone_extension"
              v-model.trim="form.phone_extension"
              type="text"
              required
              :state="form_state.phone_extension"
              :placeholder="$t('doctor_create.phone_extension_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12" md="3">
          <b-button type="submit" variant="primary" size="xl">{{ $t('doctor_create.submit_button') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>


<script>
import { CountrySelect } from "vue-country-region-select";

import { mapState, mapGetters } from "vuex";
import PhoneNumberInput from "@/components/PhoneNumberInput";

export default {
  name: "doctor-create-form",
  components: {
    PhoneNumberInput,
    CountrySelect,
  },
  data() {
    return {
      form: {
        firstname: "",
        lastname: "",
        identification_type: null,
        identification_number: "",
        identification_expiration: "",
        country: "",
        address: "",
        town: "",
        colony: "",
        postal_code: "",
        federal_entity: "",
        mobile: "",
        mobile_extension: "",
        phone: "",
        phone_extension: "",
      },
      options: [
        { value: null, text: "Please select an option" },
        { value: 1, text: this.$t("doctor_create.id_type_passport") },
        { value: 2, text: this.$t("doctor_create.id_type_ine") },
      ],
      options_privacy: [
        { value: null, text: "Please select an option" },
        { value: 1, text: this.$t("doctor_create.id_type_public") },
        { value: 2, text: this.$t("doctor_create.id_type_private") },
      ],
      form_invalid_feedback: {},
      form_state: {},
      show: true,
      updated: false,
      options_date: {
        format: "YYYY-MM-DD",
        useCurrent: false,
      },
    };
  },
  computed: {
    ...mapState({
      country_fields: state => state.siteconf.country_fields,
    }),
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
    ...mapGetters("auth", ["deviceCountry"]),
  },
  fallbackI18n: {
    messages: {
      und: {
        doctor_create: {
          firstname_label: "Firstname",
          firstname_desc: "Firstname",
          firstname_placeholder: "Firstname",
          lastname_label: "Lastname",
          lastname_desc: "Lastname",
          lastname_placeholder: "Lastname",
          mobile_label: "Mobile",
          mobile_desc: "Mobile",
          mobile_placeholder: "Mobile",
          phone_label: "Phone",
          phone_desc: "Phone",
          phone_placeholder: "Phone",
          phone_extension_label: "Phone extension",
          phone_extension_desc: "Phone extension",
          phone_extension_placeholder: "Phone extension",
          professional_number_placeholder: "Professional number",
          professional_number_label: "Professional number",
          professional_number_desc: "Professional number",
          specialty_placeholder: "Specialty",
          specialty_label: "Specialty",
          specialty_desc: "Specialty",
          privacy_placeholder: "Privacy",
          privacy_label: "Privacy",
          privacy_desc: "Privacy",
          identification_number_placeholder: "Identification number",
          identification_number_label: "Identification number",
          identification_number_desc: "Identification number",
          identification_type_label: "Identification type",
          identification_type_desc: "Identification type",
          identification_type_placeholder: "Identification type",
          identification_expiration_label: "Identification expiration",
          identification_expiration_desc: "Identification expiration",
          identification_expiration_placeholder: "Identification expiration",
          address_label: "Tax address",
          address_desc: "Tax address",
          address_placeholder: "Tax address",
          town_label: "Tax town",
          town_desc: "Tax town",
          town_placeholder: "Tax town",
          country_label: "Country",
          colony_label: "Tax colony",
          colony_desc: "Tax colony",
          colony_placeholder: "Tax colony",
          postal_code_label: "Tax postal code",
          postal_code_desc: "Tax postal code",
          postal_code_placeholder: "Tax postal code",
          federal_entity_label: "Tax federal entity",
          federal_entity_desc: "Tax federal entity",
          federal_entity_placeholder: "Tax federal entity",
          select_option: "Please select an option",
          id_type_passport: "Passport",
          id_type_ine: "INE",
          id_type_public: "Public",
          id_type_private: "Private",
          submit_button: "Save",
          reset_button: "Reset",
          error: {
            saving_doctordata: "Error saving data, check form errors.",
            retrieve_doctor_data: "Cannot retrieve doctor data",
          },
        },
      },
    },
  },
  created() {
    this.loadDoctorData();
  },
  methods: {
    loadDoctorData: function() {
      if (this.$route.params.doctor_uuid != undefined) {
        this.$store
          .dispatch("naturalperson/GET_DOCTOR", {
            doctor_uuid: this.$route.params.doctor_uuid,
          })
          .then(
            response => {
              var doctor = response.data;
              if (doctor) {
                this.form = doctor;
                this.updated = true;
                this.doctor_uuid = doctor.uuid;
              }
            },
            e => {
              this.$sentry({ capture: e });
              this.mnotify_error({
                text: this.$t("doctor_create.error.retrieve_doctor_data"),
              });
            }
          );
      }
    },
    sendForm(evt) {
      evt.preventDefault();
      var data = this.form;
      var url = "naturalperson/NEW_DOCTOR";
      var data_send = { data: data };
      if (this.updated) {
        url = "naturalperson/PATCH_DOCTOR";
        data_send = { data: data, doctor_uuid: this.doctor_uuid };
      }
      this.$store.dispatch(url, data_send).then(
        () => {
          this.$store.dispatch("naturalperson/REQUEST_DOCTOR").then(() => {
            this.$router.push({
              name: "doctorlist",
            });
          });
        },
        err => {
          this.showResponseError(err);
          this.putFormFeedback(err.response);
          this.mnotify_error({
            text: this.$t("doctor_create.error.saving_doctordata"),
          });
        }
      );
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      for (var prop in this.form) {
        if (this.form.hasOwnProperty(prop)) {
          delete this.form[prop];
        }
      }
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>